import React, {
  FC, useState,
} from 'react';
import {
  Row,
} from './Styles';
import Header from '../../../../Common/Header';
import { getCabId32Str } from '../../../../../../lib/utils/utils';
import { Box } from '../../../../../../lib/types';
import RegularBox from './components/RegularBox';
import LargeBox from './components/LargeBox';
import Title from './components/Title';
import OpenBtn from './components/OpenBtn';
import OpenBoxSuccess from '../../OpenBox/Code/OpenBoxSuccess';

const CabSizeSelect: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  platform,
  driverId,
  smallCabId,
  largeCabId,
  cabFreeStatus,
  onClose,
  parcelUserId,
  parcelUserName,
  parcelPhoneNumber,
  searchUserType,
}) => {
  const [selectCabId, setSelectCabId] = useState<number>();
  const [showQuestion, setShowQuestion] = useState<boolean>(false);
  // 普通柜子是否有空闲柜门
  const [smallCabHasFreeBox] = useState<boolean>(cabFreeStatus.find((item) => item.cabId === smallCabId)?.hasFreeBox || false);
  // 加大柜子是否有空闲柜门
  const [largeCabHasFreeBox] = useState<boolean>(cabFreeStatus.find((item) => item.cabId === largeCabId)?.hasFreeBox || false);
  const [orderInfo, setOrderInfo] = useState<{ pickupCode: string; orderId: number; openBoxes: Box[] }>();

  return (
    <div>
      {
        !orderInfo && (
          <>
            {/* 头部 */}
            <Header
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              style={{ marginTop: 20 }}
              supportIsOnlyCall={true}
              cabId32Str={getCabId32Str(smallCabId)}
            />

            <Title
              isEnglish={isEnglish}
              showQuestion={showQuestion}
              setShowQuestion={setShowQuestion}
              onClose={onClose}
            />

            <Row style={{ justifyContent: 'center', marginTop: 20 }}>
              {/* 小柜 */}
              <RegularBox
                isEnglish={isEnglish}
                smallCabId={smallCabId}
                selectCabId={selectCabId}
                setSelectCabId={setSelectCabId}
                setShowQuestion={setShowQuestion}
                smallCabHasFreeBox={smallCabHasFreeBox}
              />
              {/* 大柜 */}
              <LargeBox
                isEnglish={isEnglish}
                largeCabId={largeCabId}
                selectCabId={selectCabId}
                setSelectCabId={setSelectCabId}
                setShowQuestion={setShowQuestion}
                largeCabHasFreeBox={largeCabHasFreeBox}
              />
            </Row>

            <OpenBtn
              isEnglish={isEnglish}
              setShowLoading={setShowLoading}
              platform={platform}
              driverId={driverId}
              selectCabId={selectCabId}
              setSelectCabId={setSelectCabId}
              smallCabId={smallCabId}
              largeCabId={largeCabId}
              onClose={onClose}
              smallCabHasFreeBox={smallCabHasFreeBox}
              largeCabHasFreeBox={largeCabHasFreeBox}
              parcelUserId={parcelUserId}
              parcelUserName={parcelUserName}
              searchUserType={searchUserType}
              rentSuccess={(orderId, openCode, openBoxes) => {
                setOrderInfo({ pickupCode: openCode + '', orderId, openBoxes });
              }}
            />
          </>
        )
      }

      {
        orderInfo && (
          <OpenBoxSuccess
            cabId32Str={cabId32Str}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
            pickupCode={orderInfo.pickupCode}
            orderId={orderInfo.orderId}
            platform={platform}
            onClose={onClose}
            openedBoxes={orderInfo.openBoxes}
            parcelPhoneNumber={parcelPhoneNumber}
          />
        )
      }
    </div>
  );
};

export interface Props {
  cabId32Str: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  platform: number;
  driverId: number;
  smallCabId: number;
  largeCabId: number;
  cabFreeStatus: { cabId: number; hasFreeBox: boolean }[];
  onClose: () => void;
  parcelUserId: number;
  parcelUserName: string;
  parcelPhoneNumber: string;
  searchUserType: string;
}

export default CabSizeSelect;
